import type { ViewerEntityId } from './contracts/models';

const entityKey = (id: ViewerEntityId): string => String(id);

export const viewerQueryKeys = {
  root: (adapterId: string, projectId: ViewerEntityId) =>
    ['ironview-interactive-viewer', adapterId, entityKey(projectId)] as const,
  layoutLists: (adapterId: string, projectId: ViewerEntityId) =>
    [...viewerQueryKeys.root(adapterId, projectId), 'layouts'] as const,
  layouts: (adapterId: string, projectId: ViewerEntityId, layoutType?: string) =>
    [
      ...viewerQueryKeys.layoutLists(adapterId, projectId),
      layoutType ?? 'all',
    ] as const,
  layout: (
    adapterId: string,
    projectId: ViewerEntityId,
    layoutId: ViewerEntityId,
  ) =>
    [
      ...viewerQueryKeys.root(adapterId, projectId),
      'layout',
      entityKey(layoutId),
    ] as const,
  markers: (
    adapterId: string,
    projectId: ViewerEntityId,
    layoutId: ViewerEntityId,
  ) =>
    [
      ...viewerQueryKeys.layout(adapterId, projectId, layoutId),
      'markers',
    ] as const,
  areaTags: (
    adapterId: string,
    projectId: ViewerEntityId,
    layoutId: ViewerEntityId,
  ) =>
    [
      ...viewerQueryKeys.layout(adapterId, projectId, layoutId),
      'area-tags',
    ] as const,
  availablePhotos: (
    adapterId: string,
    projectId: ViewerEntityId,
    layoutId: ViewerEntityId,
  ) =>
    [
      ...viewerQueryKeys.layout(adapterId, projectId, layoutId),
      'available-photos',
    ] as const,
  layoutHotspots: (
    adapterId: string,
    projectId: ViewerEntityId,
    layoutId: ViewerEntityId,
  ) =>
    [
      ...viewerQueryKeys.layout(adapterId, projectId, layoutId),
      'hotspots',
    ] as const,
  panoramaPhoto: (
    adapterId: string,
    projectId: ViewerEntityId,
    photoId: ViewerEntityId,
  ) =>
    [
      ...viewerQueryKeys.root(adapterId, projectId),
      'panorama-photo',
      entityKey(photoId),
    ] as const,
  photoHotspots: (
    adapterId: string,
    projectId: ViewerEntityId,
    photoId: ViewerEntityId,
  ) =>
    [
      ...viewerQueryKeys.panoramaPhoto(adapterId, projectId, photoId),
      'hotspots',
    ] as const,
  pdfAssets: (adapterId: string, projectId: ViewerEntityId) =>
    [...viewerQueryKeys.root(adapterId, projectId), 'pdf-assets'] as const,
};
